import {ChangeDetectorRef, Injectable} from '@angular/core';
import {VehicleRestService} from "../../api/services/vehicle.rest.service";
import {VehicleTypeRestService} from "../../api/services/vehicle-type.rest.service";
import {forkJoin, mergeMap, Observable, of, Subject, Subscription} from "rxjs";
import {VehicleTypeViewModel} from "../../core/models/vehicle-type.view-model";
import {VehicleTypeApiModel} from "../../api/models/vehicle-type.api-model";
import {map, tap} from "rxjs/operators";
import {ResultListApiModel} from "../../api/models/result-list.api.model";
import {MakeViewModel} from "../../core/models/make.view-model";
import {MakeRestService} from "../../api/services/make.rest.service";
import {QueryParamsApiModel} from "../../api/models/query-params-api.model";
import {FilterParameterApiModel} from "../../api/models/filter-parameter.api.model";
import {BodyTypeRestService} from "../../api/services/body-type.rest.service";
import {BodyTypeViewModel} from "../../core/models/body-type.view-model";
import {BodyTypeApiModel} from "../../api/models/body-type.api-model";
import {ModelRestService} from "../../api/services/model.rest.service";
import {ModelApiModel} from "../../api/models/model.api-model";
import {ModelViewModel} from "../../core/models/model.view-model";
import {BodyGenViewModel} from "../../core/models/body-gen.view-model";
import {BodyGenApiModel} from "../../api/models/body-gen.api-model";
import {BodyGenRestService} from "../../api/services/body-gen.rest.service";
import {EditionRestService} from "../../api/services/edition.rest.service";
import {EditionViewModel} from "../../core/models/edition.view-model";
import {EditionApiModel} from "../../api/models/edition.api-model";
import {VehicleViewModel} from "../../features/user/garage/vehicle.view-model";
import {VehicleInterface} from "../modal/components/add-vehicle/vehicle.interface";
import {VehicleApiModel} from "../../api/models/vehicle.api-model";
import {AbstractDictionaryViewModel} from "../../core/models/abstract-dictionary.view-model";
import {AbstractDictionaryApiModel} from "../../api/models/abstract-dictionary.api-model";
import {QueryParamsService} from "../../core/services/query-params.service";
import {HttpParams} from "@angular/common/http";
import {EquipmentCategoryApiModel} from "../../api/models/equipment-category.api-model";
import {EquipmentCategoryRestService} from "../../api/services/equipment-category.rest.service";
import {SelectItem} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";
import {getTranslatableColorOptions} from "../../core/enums/color.enum";
import {MakeApiModel} from "../../api/models/make.api.model";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {SavedAdvertisementSearchRestService} from "../../api/services/saved-advertisement-search.rest.service";
import {plainToClass} from "class-transformer";
import {SavedAdvertisementSearchApiModel} from "../../api/models/saved-advertisement-search.api-model";
import {CurrentUserViewModel} from "../../core/models/current-user.view-model";
import {Button} from "primeng/button";
import {ModalStateEvent} from "../modal/modal-state-event";
import {ModalState} from "../modal/modal-state.enum";
import {ModalService} from "../modal/modal.service";
import {OffersDataProviderService} from "../marketplace/offers.data-provider.service";
import {MarketplaceAdvertisementApiModel} from "../../api/models/marketplace-advertisement.api.model";
import {Params} from "@angular/router";
import {RxFormBuilder} from "@rxweb/reactive-form-validators";
import {StringHelper} from "../../core/helpers/string.helper";
import {format} from "date-fns";
import {HashtagApiModel} from "../../api/models/hashtag.api.model";
import {EventProviderService} from '../../features/event/event-provider.service';
import {TransmissionRestService} from "../../api/services/transmission.rest.rervice";
import {TransmissionApiModel} from "../../api/models/transmission.api.model";
import {TransmissionInterface} from "../../features/user/project/parameters/transmission-interface";
import {ResponseNotificationService} from "../../core/services/response-notification.service";
import {
  getSessionStorageItem,
  removeSessionStorageItem,
  setSessionStorageItem
} from "../../core/helpers/browser-storage.helper";

@Injectable({
  providedIn: 'root'
})
export class FiltersDataProviderService {

  public vehicleTypes: VehicleTypeViewModel[] = [];
  public makes: MakeViewModel[] = [];
  public bodyTypes: BodyTypeViewModel[] = [];
  public models: ModelViewModel[] = [];
  public form: UntypedFormGroup;
  public filtersSnapshot: object = {};
  public queryParams: QueryParamsApiModel = new QueryParamsApiModel();
  public fuelTypes: SelectItem[] = [];
  public equipmentCategoryCollection: EquipmentCategoryApiModel[] = [];
  public filtersPrefetched: boolean = false;
  public eventFiltersPrefetched: boolean = false;
  public readonly colours: SelectItem[] = getTranslatableColorOptions();
  public subscription: Subscription;
  public subscriptions: Subscription[] = [];
  private adsCountSubscription?: Subscription;
  private eventsCountSubscription?: Subscription;
  public subject: Subject<ModalStateEvent> = new Subject<ModalStateEvent>();

  constructor(
    private readonly fb: RxFormBuilder,
    private vehicleTypeRS: VehicleTypeRestService,
    private makeRS: MakeRestService,
    private bodyTypeRS: BodyTypeRestService,
    private modelRS: ModelRestService,
    private bodyGenRS: BodyGenRestService,
    private editionRS: EditionRestService,
    private vehicleRS: VehicleRestService,
    private params: QueryParamsService,
    private readonly equipmentCategoryRS: EquipmentCategoryRestService,
    private readonly saveAdvertisementSearchRS: SavedAdvertisementSearchRestService,
    private readonly translate: TranslateService,
    private readonly offerDPS: OffersDataProviderService,
    private readonly eventPS: EventProviderService,
    private readonly ms: ModalService,
    private transmissionRS: TransmissionRestService,
    private readonly notifications: ResponseNotificationService,
  ) {
    this.fuelTypes = [
      { label: this.translate.instant('common.gasoline'), value: ['Gasoline', 'petrol', 'Petrol', 'Gas', 'Gasoline, Gas', 'Rotor'] },
      { label: this.translate.instant('common.diesel'), value: ['Diesel', 'diesel', 'Diesel, Hybrid'] },
      { label: this.translate.instant('common.electric'), value: ['Electric'] },
      { label: this.translate.instant('common.hybrid'), value: ['Hybrid', 'hybrid', 'Diesel, Hybrid', 'Gasoline, Electric'] },
      { label: this.translate.instant('common.lpg'), value: ['Liquefied coal hydrogen gases'] }
    ];
  }

  public seekMakes(vehicleTypeVMs: AbstractDictionaryViewModel<AbstractDictionaryApiModel>[]): Observable<MakeViewModel[]> {
    this.subject.next(new ModalStateEvent(ModalState.PROCESS));
    this.disableRelatedChoices('project.vehicle.make', ['project.vehicle.make', 'project.vehicle.model']);
    this.unsubscribePending();
    return this.getMakeCollection(vehicleTypeVMs).pipe(tap(() => {
      this.form.controls['project.vehicle.make'].enable();
      this.subject.next(new ModalStateEvent(ModalState.PROCESS_END));
    }));
  }

  public seekModels(vehicleTypeVM: VehicleTypeViewModel[], makeVM: MakeViewModel[]): Observable<ModelViewModel[]> {
    this.subject.next(new ModalStateEvent(ModalState.PROCESS));
    this.disableRelatedChoices('project.vehicle.model', ['project.vehicle.model']);
    this.unsubscribePending();
    return this.getModelCollection([vehicleTypeVM, makeVM]).pipe(tap(() => {
      this.form.controls['project.vehicle.model'].enable();
      this.subject.next(new ModalStateEvent(ModalState.PROCESS_END));
    }));
  }

  public getVehicleTypeCollection(): Observable<VehicleTypeViewModel[]> {
    return this.vehicleTypeRS.getVehicleTypeCollection()
      .pipe(map((vehicleTypeAMs: ResultListApiModel<VehicleTypeApiModel>) => {
        return vehicleTypeAMs.records.map((vehicleTypeAM: VehicleTypeApiModel) => new VehicleTypeViewModel(vehicleTypeAM))
      }))
  }

  public getMakeCollection(vehicleTypeVM: AbstractDictionaryViewModel<AbstractDictionaryApiModel>[]): Observable<MakeViewModel[]> {
    const queryParams = new QueryParamsApiModel();
    this.appendDictionaryFilters(queryParams, [vehicleTypeVM]);
    return this.makeRS.getMakeCollection(queryParams).pipe(map((makeAMs: ResultListApiModel<MakeApiModel>) => {
      this.makes  = makeAMs.records.map((makeAM: MakeApiModel) => new MakeViewModel(makeAM));
      return this.makes;
    }));
  }

  public getBodyTypeCollection(
    vms: AbstractDictionaryViewModel<AbstractDictionaryApiModel>[][]
  ): Observable<BodyTypeViewModel[]> {
    const queryParams = new QueryParamsApiModel();
    this.appendDictionaryFilters(queryParams, vms);
    return this.bodyTypeRS.getBodyTypeCollection(queryParams).pipe(map((bodyTypeAMs: ResultListApiModel<BodyTypeApiModel>) => {
      const bodyTypes = bodyTypeAMs.records.map((bodyTypeAM: BodyTypeApiModel) => new BodyTypeViewModel(bodyTypeAM));
      bodyTypes.forEach(e => e.name === '' ? e.name = 'Unknown' : null);
      return bodyTypes;
    }));
  }

  public getModelCollection(
    vms: AbstractDictionaryViewModel<AbstractDictionaryApiModel>[][]
  ): Observable<ModelViewModel[]> {
    const queryParams = new QueryParamsApiModel();
    this.appendDictionaryFilters(queryParams, vms);
    return this.modelRS.getModelCollection(queryParams).pipe(map((modelAMs: ResultListApiModel<ModelApiModel>) => {
      this.models = modelAMs.records.map((modelAM: ModelApiModel) => new ModelViewModel(modelAM));
      return this.models;
    }));
  }

  public getBodyGenCollection(
    vms: AbstractDictionaryViewModel<AbstractDictionaryApiModel>[][]
  ): Observable<BodyGenViewModel[]> {
    const queryParams = new QueryParamsApiModel();
    this.appendDictionaryFilters(queryParams, vms);
    return this.bodyGenRS.getBodyGenCollection(queryParams).pipe(map((bodyGenAMs: ResultListApiModel<BodyGenApiModel>) => {
      return bodyGenAMs.records.map((bodyGenAM: BodyGenApiModel) => new BodyGenViewModel(bodyGenAM));
    }));
  }

  public getEditionCollection(
    vms: AbstractDictionaryViewModel<AbstractDictionaryApiModel>[][]

  ): Observable<EditionViewModel[]> {
    const queryParams = new QueryParamsApiModel();
    this.appendDictionaryFilters(queryParams, vms);
    return this.editionRS.getEditionCollection(queryParams).pipe(map((bodyGenAMs: ResultListApiModel<EditionApiModel>) => {
      return bodyGenAMs.records.map((bodyGenAM: EditionApiModel) => new EditionViewModel(bodyGenAM));
    }));
  }

  public getVehicleByParams(vehicleForm: VehicleInterface): Observable<VehicleViewModel[]> {
    const keys = Object.keys(vehicleForm);
    const queryParams = new QueryParamsApiModel();
    for (let key of keys) {
      const selectedValue = vehicleForm[key];
      if (selectedValue && selectedValue['@id']) {
        queryParams.filters.push(new FilterParameterApiModel(key, selectedValue['@id'], 'single'));
      }
    }
    return this.vehicleRS.getVehicleCollection(queryParams)
      .pipe(map((vehicleAMs: ResultListApiModel<VehicleApiModel>) => {
         return vehicleAMs.records.map((vehicleAM: VehicleApiModel) => new VehicleViewModel(vehicleAM));
      }));
  }

  public getTransmissionCollectionByIds(ids: string[]): Observable<TransmissionInterface[]> {
    const uniqueIds = Array.from(new Set(ids.filter((id: string) => typeof id === 'string' && id.length > 0)));
    if (!uniqueIds.length) {
      return of([]);
    }

    const queryParams = new QueryParamsApiModel();
    uniqueIds.forEach((id: string) => {
      queryParams.filters.push(new FilterParameterApiModel('id', id, 'array'));
    });

    return this.transmissionRS.getTransmissionCollection(queryParams)
      .pipe(map((transmissionAMs: ResultListApiModel<TransmissionApiModel>) => transmissionAMs.records));
  }

  public getTransmissionCollectionByVehicleParams(vehicleForm: VehicleInterface): Observable<TransmissionInterface[]> {
    const queryParams = new QueryParamsApiModel();
    const supportedKeys: string[] = ['vehicleType', 'make', 'bodyType', 'model', 'bodyGen', 'edition'];

    supportedKeys.forEach((key: string) => {
      const selectedValue = vehicleForm[key];
      if (selectedValue && selectedValue['@id']) {
        queryParams.filters.push(new FilterParameterApiModel(`vehicles.${key}`, selectedValue['@id'], 'single'));
      }
    });

    return this.transmissionRS.getTransmissionCollection(queryParams)
      .pipe(map((transmissionAMs: ResultListApiModel<TransmissionApiModel>) => transmissionAMs.records));
  }

  updateMarketplaceFilters(): Observable<any> {
    if (!this.filtersPrefetched) {
      this.filtersSnapshot = QueryParamsService.getNormalizedQueryParametersFromSessionStorage();
      return this.getAdvancedFiltersDependencies()
        .pipe(mergeMap(() => this.fetchAdditionalDependencies()), tap(() => {
          this.updateMarketplaceFiltersForm();
          this.filtersPrefetched = true;
        }))
    } else {
      this.updateMarketplaceFiltersForm();
      return of(null);
    }

  }

  fetchAdditionalDependencies(): any {
    const additionalDependencies: Observable<any>[] = [];
    const vehicleTypeArr = this.assignAbstractViewModelFromQueryParamsSnapshot('project.vehicle.vehicleType', VehicleTypeViewModel);
    additionalDependencies.push(vehicleTypeArr.length ? this.seekMakes(vehicleTypeArr) : of([]));
    const makeArr = this.assignAbstractViewModelFromQueryParamsSnapshot('project.vehicle.make', MakeViewModel);
    additionalDependencies.push(makeArr.length ? this.getModelCollection([vehicleTypeArr, makeArr]) : of([]));

    return forkJoin(additionalDependencies);
  }

  private assignAbstractViewModelFromQueryParamsSnapshot(key: string, T: any): AbstractDictionaryViewModel<AbstractDictionaryApiModel>[] {
    if (this.filtersSnapshot[key] && this.filtersSnapshot[key] instanceof Array) {
      return this.filtersSnapshot[key].map(id => {
        const model = new T(new AbstractDictionaryApiModel());
        model['@id'] = id;
        return model;
      });
    }
    return [];
  }

  /**
   * THIS DECLARATION MUST BE IN THE SAME FLOW ORDER AS IN THE VIEW BECAUSE disableRelatedChoices METHOD WILL BROKE.
   */
  public createMarketplaceFiltersForm(): UntypedFormGroup {
    if (!this.form || !this.form.controls['project.vehicle.vehicleType']) {
      this.form = this.fb.group({
        'project.vehicle.engine.engineType': new UntypedFormControl({value: [], disabled: false}, []),
        'project.vehicle.bodyType': new UntypedFormControl({value: [], disabled: false}, []),
        'project.vehicle.vehicleType': new UntypedFormControl({value: [], disabled: false}, []),
        'project.vehicle.make': new UntypedFormControl({value: [], disabled: true}, []),
        'project.vehicle.model': new UntypedFormControl({value: [], disabled: true}, []),
        // bodyGen: new UntypedFormControl({value: '', disabled: true}, []),
        // edition: new UntypedFormControl({value: '', disabled: true}, []),
        'project.vehicle.bodyGen.yearFrom[gte]': new UntypedFormControl(null, []),
        'project.vehicle.bodyGen.yearTo[lte]': new UntypedFormControl(null, []),
        'project.attributes.mileage[gte]': new UntypedFormControl(null, []),
        'project.attributes.mileage[lte]': new UntypedFormControl(null, []),
        'priceGross[gte]': new UntypedFormControl(null, []),
        'priceGross[lte]': new UntypedFormControl(null, []),
        'project.vehicle.engine.capacityCm3[gte]': new UntypedFormControl(null, []),
        'project.vehicle.engine.capacityCm3[lte]': new UntypedFormControl(null, []),
        'project.vehicle.engine.enginePowerBHP[gte]': new UntypedFormControl(null, []),
        'project.vehicle.engine.enginePowerBHP[lte]': new UntypedFormControl(null, []),
        invoiceVat: new UntypedFormControl(null, []),
        invoiceVatMargin: new UntypedFormControl(null, []),
        toNegotiation: new UntypedFormControl(null, []),
        leasingAssignment: new UntypedFormControl(null, []),
        'leasingInitialFee[gte]': new UntypedFormControl(null, []),
        'leasingInitialFee[lte]': new UntypedFormControl(null, []),
        'leasingMonthlyInstallment[gte]': new UntypedFormControl(null, []),
        'leasingMonthlyInstallment[lte]': new UntypedFormControl(null, []),
        'leasingRemainingInstallments[gte]': new UntypedFormControl(null, []),
        'leasingRemainingInstallments[lte]': new UntypedFormControl(null, []),
        'leasingBuyoutValue[gte]': new UntypedFormControl(null, []),
        'leasingBuyoutValue[lte]': new UntypedFormControl(null, []),
        'project.attributes.currentColour': new UntypedFormControl(null, []),
        'project.attributes.originalColour': new UntypedFormControl(null, []),
        'project.attributes.originalPaintDiffersCurrent': new UntypedFormControl(null, []),
        'project.attributes.hasPaintCoverage': new UntypedFormControl(null, []),
        'project.attributes.hasPpfWrapCoverage': new UntypedFormControl(null, []),
        'project.attributes.hasOtherWrapCoverage': new UntypedFormControl(null, []),
        'project.attributes.hasOtherPaintCoverage': new UntypedFormControl(null, []),
        'project.attributes.imported': [null],
        'project.attributes.accidentFree': [null],
        'project.attributes.damaged': [null],
        'project.attributes.rightSideSteeringWheel': [null],
        'project.attributes.registeredInCountry': [null],
        'project.attributes.asoService': [null],
        'project.attributes.registeredAsAntique': [null],
        'project.attributes.mechanicalTuning': [null],
        'project.attributes.visualTuning': [null],
        'project.attributes.truckApproval': [null],
        'project.vehicle.bodyWork.numOfSeater': new UntypedFormControl({value: [], disabled: false}, []),
        'project.vehicle.bodyWork.numOfDoors': new UntypedFormControl({value: [], disabled: false}, []),
        'project.equipment': new UntypedFormControl({value: [], disabled: false}, []),
        address: [null],
        distance: new UntypedFormControl({value: 0, disabled: false}, []),
      });
    }

    return this.form;
  }

  public createEventFiltersForm(): UntypedFormGroup {
    if (!this.form || !this.form.controls['name']) {
      this.form = this.fb.group({
        name: new UntypedFormControl(null, []),
        organizerQuery: new UntypedFormControl(null, []),
        organizers: new UntypedFormControl([], []),
        hashtags: new UntypedFormControl([], []),
        address: new UntypedFormControl(null, []),
        distance: new UntypedFormControl({value: 0, disabled: false}, []),
        dateRange: new UntypedFormControl(null, []),
        includeArchived: new UntypedFormControl(false, []),
      });
    }

    return this.form;
  }

  public createUserFiltersForm(): UntypedFormGroup {
    if (!this.form || !this.form.controls['userLocation']) {
      this.form = this.fb.group({
        address: new UntypedFormControl(null, []),
        distance: new UntypedFormControl({value: 1000, disabled: false}, []),
        userLocation: new UntypedFormControl(true, [])
      });
    }

    return this.form;
  }

  public createProjectFiltersForm(): UntypedFormGroup {
    if (!this.form || !this.form.controls['projectLocation']) {
      this.form = this.fb.group({
        'attributes.registrationPlate': new UntypedFormControl(null, []),
        address: new UntypedFormControl(null, []),
        distance: new UntypedFormControl({value: 1000, disabled: false}, []),
        projectLocation: new UntypedFormControl(true, [])
      });
    }

    return this.form;
  }

  updateEventFilters(): Observable<any> {
    if (!this.eventFiltersPrefetched) {
      this.filtersSnapshot = QueryParamsService.getNormalizedQueryParametersFromSessionStorage();
      this.updateEventFiltersForm();
      this.eventFiltersPrefetched = true;
      return of(null);
    }

    this.updateEventFiltersForm();
    return of(null);
  }

  updateUserFilters(): Observable<any> {
    this.filtersSnapshot = QueryParamsService.getNormalizedQueryParametersFromSessionStorage();
    this.updateUserFiltersForm();
    return of(null);
  }

  updateProjectFilters(): Observable<any> {
    this.filtersSnapshot = QueryParamsService.getNormalizedQueryParametersFromSessionStorage();
    this.updateProjectFiltersForm();
    return of(null);
  }

  updateMarketplaceFiltersForm(): void {
    this.filtersSnapshot = QueryParamsService.getNormalizedQueryParametersFromSessionStorage();
    Object.keys(this.filtersSnapshot).forEach((key: string) => {
      switch (key) {
        case 'project.vehicle.engine.engineType':
          this.filtersSnapshot[key] = this.fuelTypes.filter(e => e.value.every(e => this.filtersSnapshot[key].includes(e)));
          this.form.patchValue({
            [key]: this.filtersSnapshot[key]
          });
          break;
        case 'project.vehicle.bodyType':
          this.filtersSnapshot[key] = (this.filtersSnapshot[key] || [])
            .map((filterId: string) => this.bodyTypes.find((bodyType) => filterId === bodyType['@id']))
            .filter((bodyType): bodyType is BodyTypeViewModel => !!bodyType);
          this.form.patchValue({
            [key]: this.filtersSnapshot[key]
          });
          break
        case 'project.vehicle.vehicleType':
          const vehicleTypesValue = this.vehicleTypes.filter(e => this.filtersSnapshot['project.vehicle.vehicleType'].includes(e['@id']));
          if (vehicleTypesValue.length) {
            this.form.patchValue({
              'project.vehicle.vehicleType': vehicleTypesValue
            });
            this.form.controls['project.vehicle.vehicleType'].enable();
          }
          break;
        case 'project.vehicle.make':
          const makesValue = this.makes.filter(e => this.filtersSnapshot['project.vehicle.make']?.includes(e['@id']));
          this.form.patchValue({
            'project.vehicle.make': makesValue
          });
          this.form.controls['project.vehicle.make'].enable();
          break;
        case 'project.vehicle.model':
          const modelsValue = this.models.filter(e => this.filtersSnapshot['project.vehicle.model']?.includes(e['@id']));
          if (modelsValue.length) {
            this.form.patchValue({
              'project.vehicle.model': modelsValue
            });
            this.form.controls['project.vehicle.model'].enable();
          }
          break;
        case 'address':
          break;
        case 'addresses.coordinates':
          const addressStr = getSessionStorageItem('marketplace.search.address') || '';
          if (addressStr.length && this.filtersSnapshot[key]) {
            const addr = JSON.parse(addressStr);
            const distance = parseInt(this.filtersSnapshot[key].split(',').pop() || "5");
            this.form.patchValue({
              address: [addr],
              distance
            });
          }
          break;
        default:
          this.form.patchValue({
            [key]: this.filtersSnapshot[key]
          });
      }

      if (this.filtersSnapshot[key].length && this.form.controls.hasOwnProperty(key)) {
        this.form.controls[key].enable();
      }
    });
  }

  updateEventFiltersForm(): void {
    this.filtersSnapshot = QueryParamsService.getNormalizedQueryParametersFromSessionStorage();
    const dateRange: Date[] = [];
    const includeArchivedStr = getSessionStorageItem('event.search.includeArchived');
    if (includeArchivedStr !== null) {
      this.form.patchValue({ includeArchived: JSON.parse(includeArchivedStr) });
    }
    Object.keys(this.filtersSnapshot).forEach((key: string) => {
      switch (key) {
        case 'addresses.coordinates':
          const addressStr = getSessionStorageItem('event.search.address') || '';
          if (addressStr.length && this.filtersSnapshot[key]) {
            const addr = JSON.parse(addressStr);
            const distance = parseInt(this.filtersSnapshot[key].split(',').pop() || "0");
            this.form.patchValue({
              address: [addr],
              distance
            });
          }
          break;
        case 'eventDates.start[after]':
          dateRange[0] = new Date(this.filtersSnapshot[key]);
          break;
        case 'eventDates.end[before]':
          dateRange[1] = new Date(this.filtersSnapshot[key]);
          break;
        case 'hashtags.name':
          const hashtags = (this.filtersSnapshot[key] as string[] || []).map((name: string) => {
            return plainToClass(HashtagApiModel, {name});
          });
          this.form.patchValue({ hashtags });
          break;
        case 'organizers':
          this.form.patchValue({ organizers: this.filtersSnapshot[key] });
          break;
        case 'fromFuture':
          break;
        default:
          if (this.form.controls.hasOwnProperty(key)) {
            this.form.patchValue({
              [key]: this.filtersSnapshot[key]
            });
          }
      }
    });

    if (dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      this.form.patchValue({ dateRange });
    } else {
      this.form.patchValue({ dateRange: null });
    }
  }

  updateUserFiltersForm(): void {
    this.filtersSnapshot = QueryParamsService.getNormalizedQueryParametersFromSessionStorage();
    const addressStr = getSessionStorageItem('user.search.address') || '';
    Object.keys(this.filtersSnapshot).forEach((key: string) => {
      if (key === 'info.city.coordinates' && addressStr.length) {
        const addr = JSON.parse(addressStr);
        const distance = parseInt(this.filtersSnapshot[key].split(',').pop() || "1000");
        this.form.patchValue({
          address: [addr],
          distance
        });
      }
    });
  }

  updateProjectFiltersForm(): void {
    this.filtersSnapshot = QueryParamsService.getNormalizedQueryParametersFromSessionStorage();
    const addressStr = getSessionStorageItem('project.search.address') || '';
    Object.keys(this.filtersSnapshot).forEach((key: string) => {
      if (key === 'user.info.city.coordinates' && addressStr.length) {
        const addr = JSON.parse(addressStr);
        const distance = parseInt(this.filtersSnapshot[key].split(',').pop() || "1000");
        this.form.patchValue({
          address: [addr],
          distance
        });
      }

      if (key === 'attributes.registrationPlate' && this.form?.controls['attributes.registrationPlate']) {
        this.form.patchValue({
          'attributes.registrationPlate': this.filtersSnapshot[key]
        });
      }
    });
  }

  public appendDictionaryFilters(queryParams: QueryParamsApiModel, vms: AbstractDictionaryViewModel<AbstractDictionaryApiModel>[][], filterName: string = null): void {
    if (!vms?.length) {
      return;
    }

    vms.forEach((vm: AbstractDictionaryViewModel<AbstractDictionaryApiModel>[]) => {
      if (!vm?.length) {
        return;
      }

      vm.forEach((item) => {
        switch (true) {
          case item instanceof VehicleTypeViewModel:
            queryParams.filters.push(new FilterParameterApiModel(filterName || 'vehicles.vehicleType', item["@id"], 'array'));
            break;
          case item instanceof MakeViewModel:
            queryParams.filters.push(new FilterParameterApiModel(filterName || 'vehicles.make', item["@id"], 'array'));
            break;
          case item instanceof ModelViewModel:
            queryParams.filters.push(new FilterParameterApiModel(filterName || 'vehicles.model', item["@id"], 'array'));
            break
          case item instanceof BodyTypeViewModel:
            queryParams.filters.push(new FilterParameterApiModel(filterName || 'vehicles.bodyType', item["@id"], 'array'));
            break;
          case item instanceof BodyGenViewModel:
            queryParams.filters.push(new FilterParameterApiModel(filterName || 'vehicles.bodyGen', item["@id"], 'array'));
            break;
          case item instanceof EditionViewModel:
            queryParams.filters.push(new FilterParameterApiModel(filterName || 'vehicles.edition', item["@id"], 'array'));
            break;
        }
      });
    });
  }

  public getFilters(): Params {
    const filters = this.getFiltersAsHttpParams(this.form.value);
    const normalizedQueryParamsFromSessionStorage = QueryParamsService.getNormalizedQueryParametersFromSessionStorage();
    const synced = QueryParamsService.getQueryParametersFromHttpParams(filters);

    const queryParams = QueryParamsService.syncObjects(
      normalizedQueryParamsFromSessionStorage,
      synced
    );
    delete queryParams['limit'];
    delete queryParams['page'];
    delete queryParams['pagination'];
    setSessionStorageItem('queryParams', JSON.stringify(queryParams));
    return queryParams;
  }

  public getFiltersAsHttpParams(formValue: object): HttpParams {
    const queryParams = new QueryParamsApiModel();
    const includeArchived = Object.prototype.hasOwnProperty.call(formValue, 'includeArchived')
      ? Boolean(formValue['includeArchived'])
      : null;

    const normalizeFilterValue = (value: any): string | number | null => {
      if (value === null || typeof value === 'undefined') {
        return null;
      }
      if (typeof value === 'string' || typeof value === 'number') {
        if (value === '[object Object]') {
          return null;
        }
        return value;
      }
      if (typeof value === 'object') {
        if (value['@id']) {
          return value['@id'];
        }
        if (value.id) {
          return value.id;
        }
        if (value.value && (typeof value.value === 'string' || typeof value.value === 'number')) {
          return value.value;
        }
      }
      return null;
    };

    Object.keys(formValue).forEach((k: string) => {
      if (k === 'dateRange') {
        const range = formValue[k] as Date[];
        if (range?.length === 2 && range[0] && range[1]) {
          queryParams.filters.push(new FilterParameterApiModel('eventDates.start', format(range[0], 'yyyy-MM-dd HH:mm:ss'), 'array_with_key', 'after'));
          queryParams.filters.push(new FilterParameterApiModel('eventDates.end', format(range[1], 'yyyy-MM-dd HH:mm:ss'), 'array_with_key', 'before'));
        }
        return;
      }

      if (k === 'organizers') {
        const organizers = formValue[k] as any[];
        if (organizers?.length) {
          organizers.forEach((organizer: any) => {
            const identifier = this.getOrganizerIdentifier(organizer);
            if (!identifier) {
              return;
            }
            queryParams.filters.push(new FilterParameterApiModel('organizers', identifier, 'array'));
          });
        }
        return;
      }

      if (k === 'hashtags') {
        const hashtags = formValue[k] as any[];
        if (hashtags?.length) {
          hashtags.forEach((tag: any) => {
            const name = tag?.name || tag;
            if (name) {
              queryParams.filters.push(new FilterParameterApiModel('hashtags.name', name, 'array'));
            }
          });
        }
        return;
      }

      if (k === 'includeArchived') {
        setSessionStorageItem('event.search.includeArchived', JSON.stringify(includeArchived));
        return;
      }

      if (formValue[k] instanceof Array && formValue[k].length > 0 && (formValue[k][0] instanceof AbstractDictionaryViewModel)) {
        this.appendDictionaryFilters(queryParams, [formValue[k]], k);
        return;
      }

      if (formValue[k] instanceof Array && formValue[k].length > 0 && (formValue[k][0].hasOwnProperty('value'))) {
        if (k === 'address' && formValue.hasOwnProperty('distance')) {
          const addrVal = formValue['address'];
          const distance = formValue['distance'];
          if (addrVal && addrVal[0].hasOwnProperty('value') && typeof distance === 'number') {
            const locationVal = `${addrVal[0].value.lat},${addrVal[0].value.lon},${distance}`
            const isUserFilters = Object.prototype.hasOwnProperty.call(formValue, 'userLocation');
            const isProjectFilters = Object.prototype.hasOwnProperty.call(formValue, 'projectLocation');
            if (isUserFilters) {
              queryParams.filters.push(new FilterParameterApiModel('info.city.coordinates', locationVal, 'single'));
            } else if (isProjectFilters) {
              queryParams.filters.push(new FilterParameterApiModel('user.info.city.coordinates', locationVal, 'single'));
            } else {
              queryParams.filters.push(new FilterParameterApiModel('addresses.coordinates', locationVal, 'single'));
              if (Object.prototype.hasOwnProperty.call(formValue, 'includeArchived')) {
                queryParams.filters.push(new FilterParameterApiModel('order[distance]', `${addrVal[0].value.lat},${addrVal[0].value.lon}`, 'single'));
              }
            }
          }
          return;
        }

        formValue[k].forEach((selectItem: SelectItem) => {
          if (selectItem.value instanceof Array) {
            selectItem.value.forEach((id: any) => {
              const normalized = normalizeFilterValue(id);
              if (normalized !== null) {
                queryParams.filters.push(new FilterParameterApiModel(k, normalized, 'array'));
              }
            })
          } else {
            const normalized = normalizeFilterValue(selectItem.value);
            if (normalized !== null) {
              queryParams.filters.push(new FilterParameterApiModel(k, normalized, 'array'));
            }
          }
        });
        return;
      }

      if (
        k === 'address' ||
        k === 'distance' ||
        k === 'userLocation' ||
        k === 'projectLocation'
      ) {
        return;
      }

      if (typeof formValue[k] === 'string' || typeof formValue[k] === 'number' || typeof formValue[k] === 'boolean') {
        if (formValue[k] !== '') {
          queryParams.filters.push(new FilterParameterApiModel(k, formValue[k], 'single'));
        }
      }

      if (formValue[k] instanceof Array) {
        formValue[k].forEach((value: string) => {
          queryParams.filters.push(new FilterParameterApiModel(k, value, 'array'));
        })
      }
    });

    if (includeArchived === false) {
      queryParams.filters.push(new FilterParameterApiModel('fromFuture', 'true', 'single'));
    }

    return this.params.applyParameters(queryParams);
  }

  public getAdvancedFiltersDependencies(): Observable<any> {
    return forkJoin([
      this.getVehicleTypeCollection(),
      this.getBodyTypeCollection([]),
      this.equipmentCategoryRS.getCollection()
    ]).pipe(tap(([vehicleTypeVMs, bodyTypeVMs, equipmentCategoryRLAM]:[VehicleTypeViewModel[], BodyTypeViewModel[],  ResultListApiModel<EquipmentCategoryApiModel>]) => {
      this.vehicleTypes = vehicleTypeVMs;
      this.bodyTypes = bodyTypeVMs;
      this.equipmentCategoryCollection = equipmentCategoryRLAM.records;
      this.filtersPrefetched = true;
    }));
  }

  public resetFilters(): void {
    removeSessionStorageItem('queryParams');
    removeSessionStorageItem('marketplace.search.address');
    removeSessionStorageItem('event.search.address');
    removeSessionStorageItem('event.search.includeArchived');
    removeSessionStorageItem('user.search.address');
    removeSessionStorageItem('project.search.address');
    this.makes = [];
    this.models = [];
    if (this.form?.controls['project.vehicle.make']) {
      this.form.controls['project.vehicle.make'].disable();
    }
    if (this.form?.controls['project.vehicle.model']) {
      this.form.controls['project.vehicle.model'].disable();
    }

    this.form?.reset({
      distance: this.getDefaultDistance()
    });
  }

  public isIncludingArchivedEvents(): boolean {
    try {
      return JSON.parse(getSessionStorageItem('event.search.includeArchived') || 'false') === true;
    } catch {
      return false;
    }
  }

  public enabledFilters(includeArchivedEvents: boolean = false): number {
    const filters = QueryParamsService.getNormalizedQueryParametersFromSessionStorage() || {};
    const activeFiltersCount = Object.entries(filters)
      .flatMap(([key, value]) => {
        if (key === 'fromFuture' && value === true) {
          return [];
        }
        return Array.isArray(value) ? value : [value];
      })
      .filter(e => e !== null && e !== '' && e !== false)
      .length;
    return activeFiltersCount + (includeArchivedEvents && this.isIncludingArchivedEvents() ? 1 : 0);
  }

  public saveSearch(user: CurrentUserViewModel, lastResultsCount: number, btn: Button): void {
    btn.loading = true;
    btn.disabled = true;
    this.createMarketplaceFiltersForm();
    this.updateMarketplaceFilters().pipe(mergeMap(() => {
      const filters  = this.filtersSnapshot;
      const addressStr = getSessionStorageItem('marketplace.search.address') || '{}';
      const address = typeof addressStr === "string" ? JSON.parse(addressStr) : null;
      const readableFilters = this.mapFormRawValueToArray(this.form.getRawValue());
      this.assignEquipmentLabel(readableFilters);
      const resourceAM = plainToClass(SavedAdvertisementSearchApiModel, {
        filters,
        lastResultsCount,
        readableFilters,
        address
      })
      return this.saveAdvertisementSearchRS.create(resourceAM)
    })).subscribe({
      next: () => {
        this.notifications.emitMessage(this.translate.instant('features.marketplace.saved_search.success'));
      }
    }).add(() => {
      btn.disabled = false;
      btn.loading = false;
    });

  }


  mapFormRawValueToArray(data: Record<string, any>): { property: string; label: any; type: string, appendix?: string }[] {
    return Object.entries(data)
      .filter(([, value]) => value !== null && (!Array.isArray(value) || value.length > 0)) // Pomijamy null i puste tablice
      .map(([key, value]) => {
        let label: any;
        let type: string;
        let appendix: string = null;

        if (Array.isArray(value)) {
          const labels = value.map(item => item?.name || item?.label || item);
          type = labels.length === 1 ? "string" : "array"; // Jeśli jedna wartość, traktujemy jako string
          label = labels.length === 1 ? labels[0] : labels;
        } else if (typeof value === "object" && value?.name) {
          type = "object";
          label = value.name;
        } else {
          type = typeof value;
          label = value;
        }

        if(this.includesNormalizedKey(['priceGross', 'leasingInitialFee', 'leasingMonthlyInstallment', 'leasingBuyoutValue'], key)) {
          appendix = 'currency'
        }

        if(this.includesNormalizedKey(['mileage', 'distance'], key)) {
          appendix = 'distance_unit'
        }

        if(this.includesNormalizedKey(['capacityCm3'], key)) {
          appendix = 'cm3'
        }

        if(this.includesNormalizedKey(['enginePowerBHP'], key)) {
          appendix = 'bhp'
        }

        if(this.includesNormalizedKey(['yearFrom', 'yearTo'], key)) {
          appendix = 'year'
        }

        return { property: key, label, type, appendix };
      });
  }

  private includesNormalizedKey(keysArray: string[], key: string): boolean {
    return keysArray
      .includes(StringHelper.getLastSegment(key).replace(/\[gte\]$/, '')
        .replace(/\[lte\]$/, ''));
  }

  public fetchAdvertisementsResultCount(): void {
    const queryParams = new QueryParamsApiModel();
    QueryParamsService.updateQueryParametersFromSnapshot(queryParams, this.getFilters());
    queryParams.limit = 0;
    if (this.adsCountSubscription) {
      this.adsCountSubscription.unsubscribe();
    }
    this.adsCountSubscription = this.offerDPS.getCollection(queryParams, true, null)
      .subscribe((resultAM: ResultListApiModel<MarketplaceAdvertisementApiModel>) => {
        this.offerDPS.totalItems = resultAM.total;
        if (this.ms.modalInstance) {
          this.ms.modalInstance.resetButtonBadge = this.enabledFilters() as unknown as string;
          this.ms.modalInstance.proceedButtonBadge = this.offerDPS.totalItems as unknown as string;
        }
      });
  }

  public fetchEventsResultCount(): void {
    const queryParams = new QueryParamsApiModel();
    QueryParamsService.updateQueryParametersFromSnapshot(queryParams, this.getFilters());
    queryParams.limit = 0;
    if (this.eventsCountSubscription) {
      this.eventsCountSubscription.unsubscribe();
    }
    this.eventsCountSubscription = this.eventPS.getCollection(queryParams)
      .subscribe(() => {
        if (this.ms.modalInstance) {
          this.ms.modalInstance.resetButtonBadge = this.enabledFilters(true) as unknown as string;
          this.ms.modalInstance.proceedButtonBadge = String(this.eventPS.totalItems);
        }
      }, () => {
        if (this.ms.modalInstance) {
          this.ms.modalInstance.resetButtonBadge = this.enabledFilters(true) as unknown as string;
          this.ms.modalInstance.proceedButtonBadge = '0';
        }
      });
  }

  public disableRelatedChoices(startField: string, only = []): void {
    let flag = false;
    for (const key in this.form.controls) {
      flag = key === startField && !only.length || only.includes(key);
      if (flag) {
        this.form.controls[key].reset();
        this.form.controls[key].disable({onlySelf: true, emitEvent: false});
      }
    }
  }

  assignEquipmentLabel(readableFilters: any[]) {
    const equipmentFilter = readableFilters.find(e => e.property === 'project.equipment');
    if(equipmentFilter) {
      (equipmentFilter.label as string[]).forEach((equipmentId: string, i) => {
        this.equipmentCategoryCollection.forEach((ec: EquipmentCategoryApiModel) => {
          const equipmentAM = ec.equipment.find(e => e['@id'] === equipmentId);
          if (equipmentAM) {
            equipmentFilter.label[i] = equipmentAM.name;
          }
        });
      });
    }
  }

  public unsubscribePending(): void {
    if (this.subscription instanceof Subscription) {
      this.subscription.unsubscribe();
    }
    if (this.adsCountSubscription) {
      this.adsCountSubscription.unsubscribe();
      this.adsCountSubscription = undefined;
    }
    if (this.eventsCountSubscription) {
      this.eventsCountSubscription.unsubscribe();
      this.eventsCountSubscription = undefined;
    }
  }

  public unsubscribeAll(): void {
    this.unsubscribePending();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private getDefaultDistance(): number {
    if (this.form?.controls['name']) {
      return 0;
    }
    if (this.form?.controls['project.vehicle.vehicleType']) {
      return 0;
    }
    return 1000;
  }

  private getOrganizerIdentifier(organizer: any): string | null {
    if (!organizer) {
      return null;
    }

    const userId = organizer?.user?.id || organizer?.id;
    if (userId) {
      return String(userId);
    }

    if (typeof organizer === 'string') {
      return organizer;
    }

    if (organizer.slug) {
      return organizer.slug;
    }

    const iri = organizer?.user?.['@id'] || organizer?.['@id'];
    if (typeof iri === 'string') {
      const part = iri.split('/').pop();
      return part || null;
    }

    return null;
  }
}
